export default __webpack_public_path__ + "static/media/teacher_pic3.2b8286b3.jpg";